import { Client, Site } from '../../interfaces/tenancy';
import { sites } from '../../api/sites';
import { clients } from '../../api/clients';

async function fetchClients(): Promise<Client[]> {
	try {
		return await clients.getClients();
	} catch (error) {
		throw error;
	}
}

async function fetchSites(): Promise<Site[]> {
	try {
		return await sites.getSites();
	} catch (error) {
		throw error;
	}
}

export const tenancyService = {
	fetchClients,
	fetchSites,
};
